<p-toast></p-toast>

<div class="card dashboardTable">
    <p-table #allFarmerApps [value]="tableData" [rows]="10" [paginator]="true" [globalFilterFields]="[
            'APP_ID',
            'FarmerStatus_Description',
            'farmerName',
            'Applicant_type',
            'Constituency',
            'District',
            'Block',
            'Village',
            'Scheme',
            'KYC_Status'
            ]" responsiveLayout="scroll" [rowHover]="true" dataKey="appid"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true" [loading]="loading" styleClass="p-datatable-gridlines"
        [tableStyle]="{'max-width': '80rem'}">
        <ng-template pTemplate="caption">
            <div class="grid d-flex align-items-center justify-content-end"
                [ngStyle]="{'color': 'black', 'background-color': 'white'}">
                <!-- Left side -->
                <div class="col-12 md:col-4">
                    <h5 class="m-0 table-header-text" [ngStyle]="{'color': 'black'}">{{ tableHeaderName | translate}}
                    </h5>
                </div>
                <!-- Middle section for buttons -->
                <div class="col-0 md:col-0 d-flex justify-content-center">
                   
                </div>
                <!-- Right side for search -->
                <div class="col-12 md:col-8 gap-3 d-flex align-items-center justify-content-end">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text"
                            (input)="allFarmerApps.filterGlobal($any($event.target).value, 'contains')"
                            placeholder="{{'SEARCH'| translate}}" />
                    </span>
                    <button (click)="menu.toggle($event)" pButton pRipple label="" icon="pi pi-download"
                        class="p-button-help mx-1"></button>
                    <p-menu #menu [popup]="true" [model]="exportMenu"></p-menu>
                </div>
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th>{{'S_NO'| translate}}</th>
                <th pSortableColumn="APP_ID">{{'APP_ID'| translate}}</th>
                <th pSortableColumn="FarmerStatus_Description">{{'STATUS'| translate}}
                    <p-columnFilter type="text" field="FarmerStatus_Description" display="menu"></p-columnFilter>
                </th>
                <th pSortableColumn="farmerName">{{'FARMER_NAME'| translate}}</th>
                <th pSortableColumn="Applicant_type">{{'APPLICANT_TYPE'| translate}}</th>
                <th pSortableColumn="Constituency">{{'CONSTITUENCY'| translate}}</th>
                <th pSortableColumn="District">{{'DISTRICT'| translate}}</th>
                <th pSortableColumn="Block">{{'BLOCK'| translate}}</th>
                <th pSortableColumn="Village">{{'VILLAGE'| translate}}</th>
                <th pSortableColumn="Scheme">{{'SCHEME'| translate}}</th>
                <th pSortableColumn="KYC_Status">{{'KYC_STATUS'| translate}}</th>
                <th>{{'TRACK_APPLICATION_STATUS' | translate}}</th>
            </tr>
        </ng-template>

        <ng-template pTemplate="body" let-val let-ri="rowIndex">
            <!-- <tr class="body-section"> -->
            <tr class="body-section" [ngStyle]="{'color': 'black', 'background-color': rowBackgroundColor(val)}">
                <td>{{ ri + 1 }}</td>
                <td class="clickable" (click)="selectFarmerApplication(val)">{{val?.APP_ID}}</td>
                <td>{{val?.FarmerStatus_Description }}</td>
                <td>{{val?.farmerName}}</td>
                <td>{{val?.Applicant_type}}</td>
                <td>{{val?.Constituency}}</td>
                <td>{{val?.District}}</td>
                <td>{{val?.Block}}</td>
                <td>{{val?.Village}}</td>
                <td>{{val?.Scheme}}</td>
                <td>{{val?.KYC_Status}}</td>
                 <td>
              <button *ngIf="!display" pButton pRipple pTooltip="View application status"  label=""
        class="p-button-rounded p-button-accent mx-1 my-1 btnSize" icon="pi pi-chart-bar" (click)="showDialog(val)"></button>
       
            </td>
            </tr>
        </ng-template>

        <ng-template pTemplate="summary">
            <div class="flex  justify-content-between flex-column ">
                <p>{{'IN_TOTAL_THERE_ARE'| translate}} {{tableData ?
                    tableData.length : 0 }} {{'RECORDS_ADDED'| translate}}
                </p>
                <div class="flex  justify-content-between flex-column "> 
                    <div class="flex"><div style="background-color:#99e699 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'APPROVED' | translate}}</div>
                    <div class="flex"><div style="background-color:#ffffc5 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'PENDING' | translate}}</div>
                    <div class="flex"><div style="background-color:#ffc966 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'RETUREN_PROCESS' | translate}}</div>
                    <div class="flex"><div style="background-color:#ff8080 ; width: 20px; height: 20px;border-radius: 5px;margin-bottom: 2px;margin-right: 4px;"></div>{{'REJECTED' | translate}}</div>
                </div>
            </div>
        </ng-template>

    </p-table>
</div>
<p-dialog 
  [(visible)]="display"
  [modal]="true"
  [closable]="true"
  header="Application Status {{selectedAppId}}"
  [style]="{width: '90vw', maxWidth: '95vw'}"       
  [contentStyle]="{height: 'auto', overflowX: 'auto', overflowY: 'auto'}" 
  [baseZIndex]="-101"
  [dismissableMask]="true">   <div *ngIf="viewApplicationWorkFlowDiag">
    <app-application-work-flow-diag [applicationId]="selectedAppId"></app-application-work-flow-diag>
  </div>

  <ng-template pTemplate="footer">
    <div style="display: flex; flex-wrap: wrap; gap: 1rem; align-items: center; width: 100%;padding-top: 0.5rem;">
      
      <strong style="margin-right: 1rem;">Legend:</strong>

      <span style="display: flex; align-items: center; gap: 0.4rem;">
        <span style="width: 18px; height: 18px; background-color: #2E7D32; border-radius: 4px; border: 1px solid #0003;"></span>
        <span>Approved</span>
      </span>

      <span style="display: flex; align-items: center; gap: 0.4rem;">
        <span style="width: 18px; height: 18px; background-color: #F9A825; border-radius: 4px; border: 1px solid #0003;"></span>
        <span>Pending</span>
      </span>

      <span style="display: flex; align-items: center; gap: 0.4rem;">
        <span style="width: 18px; height: 18px; background-color: #C62828; border-radius: 4px; border: 1px solid #0003;"></span>
        <span>Rejected</span>
      </span>

      <span style="display: flex; align-items: center; gap: 0.4rem;">
        <span style="width: 18px; height: 18px; background-color: #EF6C00; border-radius: 4px; border: 1px solid #0003;"></span>
        <span>Data Required</span>
      </span>

      <span style="display: flex; align-items: center; gap: 0.4rem;">
        <span style="width: 18px; height: 18px; background-color: #8E24AA; border-radius: 4px; border: 1px solid #0003;"></span>
        <span>Reply Pending</span>
      </span>
      
      <span style="display: flex; align-items: center; gap: 0.4rem;">
        <span style="width: 18px; height: 18px; background-color: #90A4AE; border-radius: 4px; border: 1px solid #0003;"></span>
        <span>Unknown</span>
      </span>

    </div>
  </ng-template>
  </p-dialog>